import React from "react";
import { PageHero } from "../../components/public/Section";

export default function Privacy() {
  return (
    <div>
      <PageHero title="Privacy Policy" breadcrumbs={["Home", "Privacy"]} />
      <section className="section container-page max-w-3xl space-y-6 text-brand-text leading-relaxed">
        <p>Ghaziabad Ophthalmological Society ("GOS") respects your privacy. This policy explains how we collect, use and protect information you provide via our website.</p>
        <h3 className="font-serif text-xl font-bold">Information We Collect</h3>
        <p>We may collect name, email, phone number and other information you voluntarily submit through contact forms, membership applications and event registrations.</p>
        <h3 className="font-serif text-xl font-bold">How We Use Information</h3>
        <p>Information is used solely for society communications, membership processing, event coordination and academic notifications. We do not sell or share personal data with third parties.</p>
        <h3 className="font-serif text-xl font-bold">Cookies & Analytics</h3>
        <p>We may use cookies to improve site experience and gather anonymous usage analytics.</p>
        <h3 className="font-serif text-xl font-bold">Contact</h3>
        <p>For privacy queries, please contact us via the Contact page.</p>
      </section>
    </div>
  );
}
